import React from 'react';
import { Modal } from 'lego-dist';
import RenderIf from 'components/RenderIf';
import ResultActionModalWrapper, {
  Content,
  Image,
  Title,
  Text,
} from './styles/ResultActionModalWrapper';

export interface IResultActionModal {
  configPopsModal?: any;
  image?: any;
  title?: string;
  text?: string;
  styles?: any;
}

const ResultActionModal: React.FC<IResultActionModal> = ({
  title,
  text,
  image,
  configPopsModal = {},
  styles = {},
}) => (
  <ResultActionModalWrapper styles={styles?.Wrapper}>
    <Modal openModal {...configPopsModal}>
      {() => (
        <Content styles={styles?.Content}>
          <RenderIf condition={image}>
            <Image src={image} styles={styles?.Image} />
          </RenderIf>
          <RenderIf condition={title}>
            <Title styles={styles.Title}>{title}</Title>
          </RenderIf>
          <RenderIf condition={text}>
            <Text styles={styles?.Text}>{text}</Text>
          </RenderIf>
        </Content>
      )}
    </Modal>
  </ResultActionModalWrapper>
);

export default ResultActionModal;
